import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MarkCard from "@/components/public/MarkCard";
export default {
  name: "ApprovalInstructions",
  components: {
    MarkCard: MarkCard
  },
  props: [],
  data: function data() {
    return {
      loading: false,
      insData: {
        msg: "",
        img: "",
        group: "",
        dept: "",
        telPerson: "",
        tel: "",
        date: "",
        address: "",
        dlList: [],
        qaList: []
      },
      href: "",
      downUrl: this.$http.defaults.baseURL // 下载地址

    };
  },
  computed: {},
  created: function created() {
    this.fetchInsData();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    fetchInsData: function fetchInsData() {
      var _this = this;

      this.loading = true;
      this.$http.get("/instruction/detail", {
        params: {
          serveId: this.$route.params.serveId
        }
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          var serveInfo = data.resData.serveInstructions;
          _this.insData = {
            msg: serveInfo.serveInstruction ? serveInfo.serveInstruction : "",
            img: data.resData.processPhoto ? data.resData.processPhoto.fileUrl : "",
            // group: "教职工，本科生，研究生，游客",
            dept: serveInfo.chargeDept ? serveInfo.chargeDept : "",
            telPerson: serveInfo.contactName ? serveInfo.contactName : "",
            tel: serveInfo.contactPhone ? serveInfo.contactPhone : "",
            date: serveInfo.handleTime ? serveInfo.handleTime : "",
            address: serveInfo.handleAddr ? serveInfo.handleAddr : "",
            dlList: data.resData.serveFile.length > 0 ? data.resData.serveFile : [],
            qaList: data.resData.qa.length > 0 ? data.resData.qa : []
          };
          _this.loading = false;

          _this.$nextTick(function () {
            _this.fetchServeDetail();
          });
        } else {
          _this.loading = false;
        }
      }).catch(function () {
        _this.loading = false;
      });
    },
    fetchServeDetail: function fetchServeDetail() {
      var _this2 = this;

      this.loading = true;
      this.$http.get("/hallServe/serveDetail", {
        params: {
          serveId: this.$route.params.serveId
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.resCode == 0) {
          _this2.insData.group = _this2.serveSubjectToString(data.resData.serve.serveTargetList);
        }

        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    serveSubjectToString: function serveSubjectToString(arr) {
      var newArr = arr.map(function (val) {
        return val.targetName;
      });
      return newArr.join("、");
    },
    download: function download(row) {
      var _this3 = this;

      this.axios({
        url: this.downUrl + "/serveFile/downloadFile",
        method: "get",
        params: {
          id: row.id
        },
        responseType: "blob" //接收类型设置，否者返回字符型

      }).then(function (res) {
        //定义文件名等相关信息
        var blob = res.data;
        var reader = new FileReader();
        var fileName = res.headers["content-disposition"].split(";")[1].split("=")[1];
        reader.readAsDataURL(blob); // ie

        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          window.navigator.msSaveBlob(blob, res.headers["content-disposition"].split("=")[1]);
        } else {
          reader.onload = function (e) {
            var a = document.createElement("a");
            a.download = fileName;
            a.href = e.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          };
        }
      }).catch(function () {
        _this3.$message.error("网络错误，请重新刷新");
      });
    }
  },
  watch: {},
  filters: {}
};